import bootstrapIcon from '../Assets/Images/icons/bootstrap.svg';
import css3Icon from '../Assets/Images/icons/css3.svg';
import html5Icon from '../Assets/Images/icons/html5.svg';
import javascriptIcon from '../Assets/Images/icons/javascript.svg';
import jqueryIcon from '../Assets/Images/icons/jquery.svg';
import reactIcon from '../Assets/Images/icons/react.svg';
import Redux from '../Assets/Images/icons/redux.svg';
import sassIcon from '../Assets/Images/icons/sass.svg';
import vercel from '../Assets/Images/icons/vercel.svg';
import Mongodb from '../Assets/Images/mongodb.jpg';
import postman from '../Assets/Images/postman-icon.svg';



const Skill_Right_API = [
    {
        icon: `${reactIcon}`,
        iconName: 'React Js',
    },
    {
        icon: `${Mongodb}`,
        iconName: 'Mongo DB',
    },
    {
        icon: `${Redux}`,
        iconName: 'Redux',
    },
    {
        icon: `${javascriptIcon}`,
        iconName: 'Javascript',
    },
    {
        icon: `${html5Icon}`,
        iconName: 'HTML 5',
    },
    {
        icon: `${css3Icon}`,
        iconName: 'CSS 3',
    },
    {
        icon: `${postman}`,
        iconName: 'Postman',
    },
    {
        icon:`${vercel}`,
        iconName:'Vercel',
    },
    {
        icon: `${bootstrapIcon}`,
        iconName: 'Bootstrap',
    },
    {
        icon: `${sassIcon}`,
        iconName: 'SCSS',
    },
    
    {
        icon: `${jqueryIcon}`,
        iconName: 'jQuery',
    },
   
    // {
    //     icon: `${OpenWhether}`,
    //     iconName: 'Open Whether',
    // },
    // {
    //     icon: `${DummyJsn}`,
    //     iconName: 'Dummy Json',
    // },
]
export default Skill_Right_API;